import React from "react";
import { FaBalanceScale, FaHandshake, FaGavel, FaShieldAlt } from "react-icons/fa";
import courtroomBg from "../../assets/images/Herosection/herobanner.jpg";

const WhyChooseUs = () => {
  const COLORS = {
    black: "#0A0A0A",
    dark: "#121212",
    gold: "#C8A27C", // Consistent Brand Gold
    textLight: "#EAEAEA",
  };

  const pillars = [
    {
      title: "15+ Years of Mastery",
      desc: "A legacy of transparency and results-driven advocacy across Uttar Pradesh and Delhi's courts.",
      icon: <FaBalanceScale />,
    },
    {
      title: "Client-First Ethics",
      desc: "Every case is handled with precision, strategy, and a commitment to your peace of mind.",
      icon: <FaHandshake />,
    },
    {
      title: "Strategic Litigation",
      desc: "From first consultation to final outcome, we stand by you with consistent courtroom clarity.",
      icon: <FaShieldAlt />,
    },
    {
      title: "Dedicated Advocacy",
      desc: "Specialized expertise across Civil, Criminal, Matrimonial, and Court Marriage legal matters.",
      icon: <FaGavel />,
    },
  ];

  return (
    <section className="relative overflow-hidden font-serif bg-[#0A0A0A]">
      {/* HEADER HERO AREA */}
      <div className="relative py-28 lg:py-36 px-6">
        {/* Background Image with Layered Overlays */}
        <div className="absolute inset-0 z-0">
          <img 
            src={courtroomBg} 
            alt="Legal Consultation" 
            className="w-full h-full object-cover opacity-30 grayscale brightness-50"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-[#0A0A0A]/90 to-[#0A0A0A]"></div>
        </div>

        <div className="max-w-7xl mx-auto relative z-10 text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="h-[1px] w-10 bg-[#C8A27C]" />
            <p className="uppercase tracking-[0.5em] text-[10px] font-bold text-[#C8A27C]">
              The Dagar Difference
            </p>
            <div className="h-[1px] w-10 bg-[#C8A27C]" />
          </div>

          <h2 className="text-4xl md:text-6xl text-white font-bold mb-10 tracking-tight leading-tight">
            Why Clients <br />
            <span className="italic font-normal opacity-70" style={{ color: COLORS.gold }}>Trust Our Counsel</span>
          </h2>

          <div className="max-w-3xl mx-auto">
            <p className="text-gray-400 text-lg md:text-xl leading-relaxed font-sans font-light">
              Trusted for transparency and relentless dedication. We combine 
              deep legal expertise with a genuine commitment to client success, 
              ensuring precision in every Ghaziabad courtroom battle.
            </p>
          </div>
        </div>
      </div>

      {/* PILLARS AREA */}
      <div className="relative pb-24 px-6 lg:px-20">
        <div className="max-w-7xl mx-auto -mt-20 relative z-20">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 rounded-3xl overflow-hidden border border-white/10 bg-white/5 backdrop-blur-md">
            {pillars.map((item, index) => (
              <div
                key={index}
                className="p-12 border-white/5 border-[0.5px] group hover:bg-[#C8A27C] transition-all duration-700"
              >
                {/* Icon Container */}
                <div
                  className="w-16 h-16 flex items-center justify-center rounded-2xl mb-8 text-3xl bg-white/5 text-[#C8A27C] group-hover:bg-black group-hover:scale-110 transition-all duration-500 shadow-xl"
                >
                  {item.icon}
                </div>

                {/* Title */}
                <h4 className="text-xl font-serif font-bold text-white mb-4 group-hover:text-black transition-colors duration-500">
                  {item.title}
                </h4>

                {/* Desc */}
                <p className="text-gray-400 text-sm leading-relaxed font-sans group-hover:text-black/80 transition-colors duration-500">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>

          {/* FLOATING CTA SECTION */}
          <div
            className="mt-24 max-w-5xl mx-auto rounded-3xl p-12 md:p-16 text-center shadow-2xl relative border border-white/10 overflow-hidden"
            style={{ backgroundColor: COLORS.dark }}
          >
            {/* Background Justice Accent */}
            <div className="absolute -bottom-10 -right-10 text-[15vw] font-black text-white/[0.02] select-none uppercase italic">
              Scale
            </div>

            <div
              className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-[3px]"
              style={{ backgroundColor: COLORS.gold }}
            ></div>

            <h3 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6">
              Seeking Legal <span className="italic font-normal" style={{ color: COLORS.gold }}>Guidance?</span>
            </h3>

            <p className="text-gray-400 font-sans mb-12 max-w-2xl mx-auto text-lg">
              Facing a complex legal issue? We provide expert strategy 
              and practical solutions to protect your rights and future.
            </p>

            <a
              href="/contact-us"
              className="inline-block relative px-12 py-5 font-bold tracking-[0.2em] uppercase text-xs transition-all duration-500 bg-[#C8A27C] text-black hover:bg-white hover:scale-105 rounded-sm"
            >
              Schedule Consultation Now
            </a>
          </div>
        </div>
      </div>
      
      {/* Justice Accent Decoration */}
      <div className="absolute top-1/2 left-0 -translate-x-1/2 w-96 h-96 bg-[#C8A27C]/5 rounded-full blur-[150px] pointer-events-none"></div>
    </section>
  );
};

export default WhyChooseUs;